import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import FundsTable from "../components/FundsTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faMagnifyingGlass, faAngleUp, faRotateRight, faChartSimple } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { formatLargeNumber } from '../utils/currencyUtils';

function Retirement() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [search, setSearch] = useState();
  const [mutualfunds, setMutualfunds] = useState([]);
  const [etfs, setEtfs] = useState([]);
  const [allFunds, setAllFunds] = useState([]);
  const [filteredFunds, setFilteredFunds] = useState([]);
  useEffect(() => {
      fetch(`/uploads/investment/etfs.txt`)
      .then((res) => res.json())
      .then((data) => {
      var investment = data;
        setEtfs(investment);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
      fetch(`/uploads/investment/mutualfunds.txt`)
      .then((res) => res.json())
      .then((data) => {
      var investment = data;
        setMutualfunds(investment);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!etfs.length && !mutualfunds.length) return;
    const merged = [...etfs, ...mutualfunds];
    for (let i = merged.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [merged[i], merged[j]] = [merged[j], merged[i]];
    }
    setAllFunds(merged);
    setFilteredFunds(merged);
  }, [etfs, mutualfunds]);
  const [dropdown, setDropdown] = useState("closed")
  const [dropdown1, setDropdown1] = useState("closed")
  // define state above your dropdown (inside the same parent component)
  const [checkedItems, setCheckedItems] = useState({
    cash: true,
    commodity: false,
    digital: false,
    equity: false,
    fixed: false,
    hedge: false,
    multi: false,
    private: false,
    realestate: false,
  });
  const handleCheckboxChange = (key) => {
    setCheckedItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  const handleReset = () => {
    setCheckedItems({
        cash: false,
        commodity: false,
        digital: false,
        equity: false,
        fixed: false,
        hedge: false,
        multi: false,
        private: false,
        realestate: false,
    });
  };
  const [fundsType, setFundsType] = useState("all")
  const [investmentStyle, setInvestmentStyle] = useState({
    active: false,
    index: false,
  });
  const handleStyleChange = (key) => {
    setInvestmentStyle((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  const handleReset1 = () => {
    setFundsType("all");
    setInvestmentStyle({ active: true, index: false });
  };

  useEffect(() => {
    if (!allFunds.length) return;
    let filtered = [...allFunds];
    if (fundsType !== "all") {
        filtered = filtered.filter(fund => fund.quoteType === fundsType);
    }
    if (search && search.trim() !== "") {
        const lowerSearch = search.toLowerCase();
        filtered = filtered.filter(fund => 
        fund.longName.toLowerCase().includes(lowerSearch) || 
        fund.symbol.toLowerCase().includes(lowerSearch) || fund.quoteType.toLowerCase().includes(lowerSearch)
        );
    }
    setFilteredFunds(filtered);
    setDropdown1("closed")
    setDropdown("closed")
  }, [fundsType, search]);

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Investments" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Investments" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
                <div className="col-12">
                <div className="bg-prime py-4 px-md-5 px-4">
                    <h1 className="mb-0 text-black display-5" style={{fontWeight:'900'}}>Investment funds</h1>
                    <h5 className="mb-0 fw-bold">Explore all mutual funds, iShares ETFs and closed-end funds</h5>
                    <div className="d-flex align-items-center flex-wrap mt-4" style={{gap:'20px'}}>
                        <div>
                            <h6 className="mb-0 fw-bold text-uppercase">Filters</h6>
                            <div className="mt-2 d-flex align-items-center flex-wrap" style={{gap:'10px'}}>
                                <div className="position-relative">
                                    <div className="d-flex align-items-center bg-black px-3 py-1" style={{height:'50px', cursor:'pointer'}} onClick={() => { setDropdown(dropdown === "closed" ? "open" : "closed");}}>
                                        <div className="me-3">
                                            <p className="text-uppercase fw-bold mb-0 lh-1" style={{fontSize:'13px'}}>FUND TYPE</p>
                                            <p className="mb-0 lh-1" style={{fontWeight:'900',fontSize:'17px'}}>All funds</p>
                                        </div>
                                        <FontAwesomeIcon icon={dropdown === "closed" ? faAngleDown : faAngleUp} className="text-prime" style={{fontSize: '18px'}} />
                                    </div>
                                    <div className={`big-dropdown-info first ${dropdown === "open" ? "open" : ""}`}>
                                        <p className="fw-bold fs-5 mb-0">Product view</p>
                                        <RadioGroup aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group" value={fundsType} onChange={(e) => setFundsType(e.target.value)}>
                                            <FormControlLabel value="all" control={<Radio />} label={`All funds (${allFunds.length})`} />
                                            <FormControlLabel value="MUTUALFUND" control={<Radio />} label={`Mutual funds (${mutualfunds.length})`} />
                                            <FormControlLabel value="ETF" control={<Radio />} label={`ETFs (${etfs.length})`} />
                                        </RadioGroup>
                                        <p className="fw-bold fs-5 mt-3 mb-0">Investment style</p>
                                        <FormGroup>
                                            <FormControlLabel control={<Checkbox checked={investmentStyle.active} onChange={() => handleStyleChange("active")} />} label="Active (511)" />
                                            <FormControlLabel control={<Checkbox checked={investmentStyle.index} onChange={() => handleStyleChange("index")} />} label="Index (533)" />
                                        </FormGroup>
                                        <div className="mt-4 px-3 py-2 d-flex justify-content-end" style={{ backgroundColor: "#ff6b3526" }}>
                                            <p className="fw-bold mb-0" style={{ cursor: "pointer" }} onClick={handleReset1} >
                                                <FontAwesomeIcon icon={faRotateRight} style={{ fontSize: "14px" }} className="me-1" /> Reset
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="position-relative">
                                    <div className="d-flex align-items-center bg-white px-3 py-1" style={{height:'50px', cursor:'pointer'}} onClick={() => { setDropdown1(dropdown1 === "closed" ? "open" : "closed");}}>
                                        <p className="mb-0 lh-1 text-black me-2" style={{fontWeight:'900',fontSize:'16px'}}>Asset class</p>
                                        <FontAwesomeIcon icon={faAngleDown} className="text-prime" style={{fontSize: '18px'}} />
                                    </div>
                                    <div className={`big-dropdown-info second ${dropdown1 === "open" ? "open" : ""}`}>
                                    <FormGroup>
                                        <FormControlLabel control={<Checkbox checked={checkedItems.cash} onChange={() => handleCheckboxChange("cash")} />} label="Cash" />
                                        <FormControlLabel control={<Checkbox checked={checkedItems.commodity} onChange={() => handleCheckboxChange("commodity")} />} label="Commodity" />
                                        <FormControlLabel control={<Checkbox checked={checkedItems.digital} onChange={() => handleCheckboxChange("digital")} />} label="Digital Assets" />
                                        <FormControlLabel control={<Checkbox checked={checkedItems.equity} onChange={() => handleCheckboxChange("equity")} />} label="Equity" />
                                        <FormControlLabel control={<Checkbox checked={checkedItems.fixed} onChange={() => handleCheckboxChange("fixed")} />} label="Fixed Income" />
                                        <FormControlLabel control={<Checkbox checked={checkedItems.hedge} onChange={() => handleCheckboxChange("hedge")} />} label="Hedge Fund of Funds" />
                                        <FormControlLabel control={<Checkbox checked={checkedItems.multi} onChange={() => handleCheckboxChange("multi")} />} label="Multi Asset (201)" />
                                        <FormControlLabel control={<Checkbox checked={checkedItems.private} onChange={() => handleCheckboxChange("private")} />} label="Private Markets" />
                                        <FormControlLabel control={<Checkbox checked={checkedItems.realestate} onChange={() => handleCheckboxChange("realestate")} />} label="Real Estate" />
                                    </FormGroup>
                                    <div className="mt-4 px-3 py-2 d-flex justify-content-end" style={{ backgroundColor: "#ff6b3526" }}>
                                        <p className="fw-bold mb-0" style={{ cursor: "pointer" }} onClick={handleReset} >
                                        <FontAwesomeIcon icon={faRotateRight} style={{ fontSize: "14px" }} className="me-1" /> Reset
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                <div className="position-relative">
                                    <div className="d-flex align-items-center bg-white px-3 py-1" style={{height:'50px', cursor:'pointer'}}>
                                        <p className="mb-0 lh-1 text-black me-2" style={{fontWeight:'900',fontSize:'16px'}}>Markets & regions</p>
                                        <FontAwesomeIcon icon={faAngleDown} className="text-prime" style={{fontSize: '18px'}} />
                                    </div>
                                </div>
                                <div className="position-relative">
                                    <div className="d-flex align-items-center bg-white px-3 py-1" style={{height:'50px', cursor:'pointer'}}>
                                        <p className="mb-0 lh-1 text-black me-2" style={{fontWeight:'900',fontSize:'16px'}}>Sustainable</p>
                                        <FontAwesomeIcon icon={faAngleDown} className="text-prime" style={{fontSize: '18px'}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h6 className="mb-0 fw-bold text-uppercase">Find funds by</h6>
                            <div className="d-flex mt-2 rounded-pill ps-3 searchCon" style={{backgroundColor:'#00000042'}}>
                                <input 
                                    type="search"
                                    placeholder="Ticker, ISIN, share class or fund name"
                                    className="inputNone placeholder-black"
                                    style={{width:'100%'}}
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <div className="rounded-circle d-flex align-items-center justify-content-center bg-black" style={{minHeight:'50px',minWidth:'50px',cursor:'pointer'}}>
                                    <FontAwesomeIcon icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                <div className="col-12">
                    <div className="mycard mt-2">
                        <div className="table-responsive hideScroll" style={{ maxHeight: "500px" }}>
                            <FundsTable allFunds={filteredFunds} formatLargeNumber={formatLargeNumber}/>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Retirement